function toggleRequired() {
    var select = document.getElementById("bw_luftwaffe_payment_method");
    var input1 = document.getElementById("bw_luftwaffe_iban");
    var input2 = document.getElementById("bw_luftwaffe_bic");
    var label1 = document.getElementById("iban-asterisk");
    var label2 = document.getElementById("bic-asterisk");

    if (select.value !== "Rechnung") {
        input1.required = true;
        input2.required = true;
        label1.innerHTML = "<span>*</span>";
        label2.innerHTML = "<span>*</span>";
    } else {
        input1.required = false;
        input2.required = false;
        label1.innerHTML = "";
        label2.innerHTML = "";
    }
}
if (document.getElementById("bw_luftwaffe_payment_method")) {
window.addEventListener("load", function () {
    // Add event listener to the select field
    var selectField = document.getElementById("bw_luftwaffe_payment_method");
    selectField.addEventListener("change", toggleRequired);

    // Check the value of the select field on page load
    toggleRequired();
});
}

